import { Badge, BadgeProps } from '@givebutter/primitives/badge';
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface PreviewBadgeProps extends Omit<BadgeProps, 'children'> {}
const PreviewBadge = ({ className, ...restProps }: PreviewBadgeProps) => {
    return (
        <Badge
            className={twMerge('border border-gray-200 bg-white shadow-sm', className)}
            {...restProps}
        >
            <FontAwesomeIcon icon={faEye} />
            Preview
        </Badge>
    );
};

export { PreviewBadge };
